// Normal-signup identity fields and the settings policy used at dispatch.
export const SIGNUP_PHONE_MESSAGE = '010·011·016·017·018·019로 시작하는 휴대폰 번호를 숫자만 입력해주세요.';
export const SIGNUP_DOB_MESSAGE = '생년월일은 실제 날짜를 930801-1 형식으로 입력해주세요.';
export const SIGNUP_POLICY_MESSAGE = '가입 설정을 확인할 수 없습니다. 잠시 후 다시 시도해주세요.';
export const isSignupPhone = value => typeof value === 'string'
  && !/[^0-9]/.test(value) && /^(?:010[0-9]{8}|01[16789][0-9]{7,8})$/.test(value);
export const formatSignupPhoneInput = value => String(value ?? '').replace(/[^0-9]/g, '').slice(0, 11);
export const isSignupCalendarDob = value => {
  if (typeof value !== 'string' || value.length !== 8 || !/^[0-9]{6}-[0-9]$/.test(value)) return false;
  const digit = Number(value[7]);
  const century = [1, 2, 5, 6].includes(digit) ? 1900 : [3, 4, 7, 8].includes(digit) ? 2000 : 1800;
  const year = century + Number(value.slice(0, 2)), month = Number(value.slice(2, 4)), day = Number(value.slice(4, 6));
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
};
export const isSignupPolicyReady = (settings, isLoading = false) => !isLoading
  && typeof settings?.use_date_of_birth === 'boolean';
export const getSignupPolicyError = (values, settings, isLoading = false) => {
  if (!isSignupPolicyReady(settings, isLoading)) return SIGNUP_POLICY_MESSAGE;
  if (!isSignupPhone(values?.phone)) return SIGNUP_PHONE_MESSAGE;
  if (settings.use_date_of_birth && !isSignupCalendarDob(values?.dob)) return SIGNUP_DOB_MESSAGE;
  return '';
};
// The fresh read happens inside the challenge callback. Failure never means DOB OFF.
export const dispatchSignupWithPolicy = async ({ values, payload, readSettings, isCurrent, dispatch }) => {
  if (!isCurrent()) return null;
  let response;
  try { response = await readSettings(); } catch { if (!isCurrent()) return null; throw new Error(SIGNUP_POLICY_MESSAGE); }
  if (!isCurrent()) return null;
  const settings = response?.status === true || response?.success === true ? response.data : undefined;
  const error = getSignupPolicyError(values, settings);
  if (error) throw new Error(error);
  const currentPayload = { ...payload, phone: values.phone };
  if (settings.use_date_of_birth) currentPayload.dob = values.dob;
  else delete currentPayload.dob;
  return dispatch(currentPayload);
};
